
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

export function insertMarkets (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/market',
    method: 'POST',
    data: parameter
  })
}
export function updateMarkets (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/market',
    method: 'POST',
    data: parameter
  })
}
export function deleteMarkets (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/market',
    method: 'DELETE',
    params: {
      ids: parameter
    }
  })
}
export function getMarketsList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/markets',
    method: 'GET',
    params: parameter
  })
}
export function getMarketsInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/market',
    method: 'GET',
    params: parameter
  })
}
// 下载已经保存的文件
export function getFilesById (filePath) {
  return axios({
    url: sysInfo.apiRemote + `/market/file/${filePath}`,
    responseType: 'blob',
    method: 'GET'
  })
}
// 下载未保存的临时文件
export function getFilesTemp (filePath) {
  return axios({
    url: sysInfo.apiRemote + `/upload/preview/tmp/${filePath}`,
    method: 'GET'
  })
}
//  获取人员列表 getUserList
export function getUserList () {
  return axios({
    url: sysInfo.apiRemote + `/user?paging=false&status=1`,
    method: 'GET'
  })
}
// 变更负责人changeLeader
export function changeLeader (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/market`,
    method: 'PUT',
    data: parameter
  })
}
